<template>
  <div class="view-container">
    <div class="text-right cursor-pointer">
      <b-button
        variant="link"
        @click="back"
      >
        <font-awesome-icon icon="times" />
      </b-button>
    </div>

    <h1
      v-if="isNuova"
      class="text-center"
    >Nuova Comunicazione</h1>
    <h1
      v-else
      class="text-center"
    >Dettaglio Comunicazione</h1>

    <b-tabs
      v-model="indexTab"
      @input="changeTab"
    >
      <b-tab
        title="Comunicazione"
        active
      >

        <loading-spinner v-if="loading" />
        <template v-else>
          <b-form
            class="form"
            @submit="onSubmit"
            @reset="onReset"
          >

            <b-form-group
              id="input-group-4"
              label="Destinatari comunicazione *"
              label-class="font-weight-bold"
            >
              <div>
                <b-form-radio
                  class="in-line-element"
                  v-model="model.tipoDest"
                  name="some-radios"
                  value="T"
                  :disabled="isReadonly"
                  @input="selectedDest"
                >Tutti i rapporti di utenza del Portale Patrimonio </b-form-radio>
                <b
                  v-if="model.tipoDest === 'T'"
                  class="in-line-element"
                >{{'  (destinatari stimati ' + tuttiDestinatari + ')'}}</b>
              </div>

              <div>
                <b-form-radio
                  class="mt-2 in-line-element"
                  v-model="model.tipoDest"
                  name="some-radios"
                  value="G"
                  :disabled="isReadonly"
                >Gruppo di rapporti utenza per tipo rapporto utenza</b-form-radio>
                <b
                  v-if="model.tipoDest === 'G'"
                  class="in-line-element"
                >{{'  (destinatari stimati ' + gruppoDestinatari + ')'}}</b>

                <b-form-select
                  v-if="isReadonly === false"
                  class="mt-1 in-line-element"
                  v-model="model.gruppo"
                  :options="tipiRapportoUtenza"
                  :disabled="model.tipoDest !== 'G'"
                  @change="selectedDest('G')"
                ></b-form-select>

                <b-form-input
                  v-else
                  class="mt-1 in-line-element"
                  :value="model.gruppo && Array.isArray(tipiRapportoUtenza) ? (tipiRapportoUtenza.find(e => e.value === model.gruppo) ? tipiRapportoUtenza.find(e => e.value === model.gruppo).text : '') : ''"
                  disabled
                ></b-form-input>

              </div>
              <div>
                <b-form-radio
                  class="mt-2 in-line-element"
                  v-model="model.tipoDest"
                  name="some-radios"
                  value="U"
                  placeholder="Seleziona rapporto utenza..."
                  :disabled="isReadonly"
                >Rapporti utenza specifici del Portale Patrimonio</b-form-radio>
                <!-- <b
                  v-if="model.tipoDest === 'U'"
                  class="in-line-element"
                >{{'  (destinatari stimati ' + selezionatiDestinatari  + ')'}}</b> -->
                <!-- <b-form-input
                  class="mt-1"
                  type="search"
                  v-model="model.utente"
                  :disabled="model.tipoDest !== 'U'"
                ></b-form-input> -->
                <b-form-file
                  v-model="fileCsv"
                  :state="Boolean(fileCsv) || isReadonly"
                  placeholder="Seleziona un file e trascinalo qui..."
                  drop-placeholder="Trascina il file qui..."
                  :disabled="isReadonly ? true : model.tipoDest !=='U'"
                  id="fileCsvSelect"
                  @input="readFile(fileCsv)"
                ></b-form-file>
                <b-button
                  variant="outline-secondary"
                  style="margin-top: 4pt"
                  class="mr-2"
                  size="sm"
                  pill
                  @click="model.utente = ''; fileCsv = null;"
                  :disabled="isReadonly ? true : model.tipoDest !=='U'"
                >Pulisci</b-button>
                <label
                  for="fileCsvSelect"
                  style="color: green"
                >
                  Rapporti utenza selezionati: {{model.tipoDest === 'U' ? model.utente : ''}}
                </label>
              </div>
              <div>
                <b-form-radio
                  class="mt-2 in-line-element"
                  v-model="model.tipoDest"
                  name="some-radios"
                  value="S"
                  placeholder="Ricerca e seleziona un singolo rapporto utenza."
                  :disabled="isReadonly"
                >Rapporto utenza specifico del Portale Patrimonio</b-form-radio>
                <!-- <b
                  v-if="model.tipoDest === 'S'"
                  class="in-line-element"
                >{{'  (destinatari stimati ' + selezionatiDestinatari + ')'}}</b> -->

                <b-form-group
                  id="input-riceca-utente"
                  label="Ricerca Rapporto Utenza."
                  label-for="input-2"
                  label-class="font-weight-bold"
                >
                  <b-form-input
                    id="input-stringa"
                    v-model="parametroRicerca"
                    required
                    placeholder="Inserire il valore di ricerca."
                    :readonly="isReadonly"
                  ></b-form-input>
                  <b-button
                    variant="outline-secondary"
                    style="margin-top: 4pt"
                    class="mr-2"
                    size="sm"
                    pill
                    @click="ricercaUtente(parametroRicerca)"
                    :disabled="isReadonly ? true : model.tipoDest !=='S'"
                  >Ricerca Utente</b-button>
                </b-form-group>
                <ricerca-utente
                  :utentiTrovati="utentiPossibili"
                  :modello="model"
                  ref="ricerca"
                  @utente="utenteScelto(selected)"
                />
                <b-button
                  variant="outline-secondary"
                  class="mr-2"
                  size="sm"
                  pill
                  @click="model.utente = ''"
                  :disabled="isReadonly ? true : model.tipoDest !=='S'"
                >Pulisci</b-button>
                <label
                  for="fileCsvSelect"
                  style="color: green"
                >
                  Rapporto utenza selezionato: {{model.tipoDest === 'S' ? model.utente : ''}}
                </label>
              </div>
            </b-form-group>

            <b-form-group
              id="input-group-1"
              label="Sezione *"
              label-for="input-1"
              label-class="font-weight-bold"
            >
              <b-form-input
                v-if="isReadonly"
                readonly
                :value="model.sezioneRiferimento"
                class="mt-1"
                :state="fieldState('sezioneRiferimento')"
                xxstate="!!model.sezioneRiferimento"
              />
              <b-form-select
                v-else
                class="mt-1"
                v-model="model.sezioneRiferimento"
                :options="sezioni"
              ></b-form-select>
              <b-form-invalid-feedback>Campo obbligatorio</b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              id="input-group-1"
              label="Testo breve *"
              label-for="input-1"
              label-class="font-weight-bold"
            >
              <b-form-input
                id="input-1"
                v-model="model.testoBreve"
                required
                placeholder="Inserire descrizione breve..."
                :readonly="isReadonly"
                xxstate="!!model.testoBreve"
                :state="fieldState('testoBreve')"
              ></b-form-input>
              <b-form-invalid-feedback>Campo obbligatorio</b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              id="input-group-2"
              label="Testo completo"
              label-for="input-2"
              label-class="font-weight-bold"
            >
              <b-form-textarea
                id="textarea"
                v-model="model.testo"
                placeholder="Inserire testo completo. Il testo deve essere inferiore a 4000 caratteri."
                rows="3"
                max-rows="6"
                :state="model.testo ? model.testo.length <= 4000 : true"
                :readonly="isReadonly"
              ></b-form-textarea>
              <b-form-invalid-feedback>Il testo deve essere inferiore a 4000 caratteri.</b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              label="Validità comunicazione *"
              label-class="font-weight-bold"
            >
              <div class="d-flex">
                <b-form-group
                  label="Data inizio:"
                  label-cols="4"
                  label-class="font-italic"
                  label-align="left"
                >
                  <b-form-input
                    type="date"
                    class="mr-2"
                    required
                    v-model="model.dataDa"
                    :readonly="isReadonly"
                    xxstate="!!model.dataDa"
                    :state="fieldState('dataDa')"
                  ></b-form-input>
                  <b-form-invalid-feedback>Campo obbligatorio</b-form-invalid-feedback>
                </b-form-group>
                <b-form-group
                  label="Data fine:"
                  label-cols="4"
                  label-class="font-italic"
                  class="ml-4"
                >
                  <b-form-input
                    type="date"
                    class="mr-2"
                    v-model="model.dataA"
                    required
                    :readonly="isReadonly"
                    xxstate="checkRangeDate(model.dataDa, model.dataA)"
                    :state="fieldState('dataA')"
                  ></b-form-input>
                  <b-form-invalid-feedback>Intervallo di date non valido</b-form-invalid-feedback>
                </b-form-group>
              </div>
            </b-form-group>

            <b-form-group
              id="input-group-3"
              :label="'Documento allegato: ' + (model ? model.nomeFile : '')"
              label-for="input-3"
              label-class="font-weight-bold"
              :readonly="isReadonly"
            >
              <b-form-file
                v-model="model.file"
                :state="Boolean(model.file)"
                placeholder="Seleziona un file e trascinalo qui..."
                drop-placeholder="Trascina il file qui..."
                :disabled="isReadonly"
                id="fileSelect"
              ></b-form-file>
              <!-- <label
                for="fileSelect"
                style="color: green"
              >
                File selezionato: {{model.nomeFile}}
              </label> -->
            </b-form-group>

            <div class="p-2"></div>

            <b-button
              variant="secondary"
              class="mr-2"
              @click="reset"
            >Torna alla lista</b-button>

            <b-button
              v-if="isNuova"
              variant="primary"
              class="mr-2"
              @click="onSubmit"
            >Inserisci Bozza</b-button>

            <template v-else>
              <b-button
                v-if="tabIndex === 1"
                variant="primary"
                class="mr-2"
                @click="onSubmit"
              >Salva Bozza</b-button>

              <!-- <b-button
            variant="info"
            class="mr-2"
            @click="allegaDocumento"
          >Allega Documento</b-button> -->

              <b-button
                v-if="tabIndex === 1"
                variant="success"
                class="mr-2"
                @click="pubblica"
              >Pubblica</b-button>

              <b-button
                v-if="tabIndex === 1"
                variant="danger"
                class="mr-2"
                @click="elimina"
              >Elimina Bozza</b-button>

            </template>

            <b-dropdown
              v-if="!isNuova"
              id="dropdown-1"
              text="Audit"
              class="mr-2"
              variant="warning"
            >
              <b-dropdown-item disabled>Creato da {{model.creatoDa}} il {{formatDateTime(model.creato)}}</b-dropdown-item>
              <b-dropdown-item
                disabled
                v-if="model.modificatoDa"
              >Aggiornato da {{model.modificatoDa}} il {{formatDateTime(model.ultimaModifica)}}</b-dropdown-item>
              <b-dropdown-item
                v-if="model.dataPubblicazione"
                disabled
              >Pubblicato da {{model.pubblicatoDa}} il {{formatDateTime(model.dataPubblicazione)}}</b-dropdown-item>
            </b-dropdown>

          </b-form>
        </template>

      </b-tab>

      <b-tab
        title="Riepilogo"
        v-if="tabIndex !== 1"
      >
        <div
          style="margin-top: 12pt"
          v-if="this.item.dataPubblicazione"
        >
          <pre style="font-size: 12pt">La comunicazione è stata pubblicata il <b>{{calcoloDataPub(this.item.dataPubblicazione)}}</b></pre>
        </div>
        <b-form-group
          id="input-group-4"
          label="Destinatari comunicazione *"
          label-class="font-weight-bold"
        >
          <div v-if="model.tipoDest ==='T'">
            <b-form-radio
              v-model="model.tipoDest"
              name="some-radios"
              value="T"
              :disabled="true"
            >Tutti i rapporti utenza del Portale Patrimonio</b-form-radio>
          </div>

          <div v-if="model.tipoDest ==='G'">
            <b-form-radio
              class="mt-2"
              v-model="model.tipoDest"
              name="some-radios"
              value="G"
              :disabled="true"
            >Gruppo di rapporti utenza per tipo rapporto utenza</b-form-radio>

            <b-form-input
              class="mt-1"
              :value="model.gruppo && Array.isArray(tipiRapportoUtenza) ? tipiRapportoUtenza.find(e => e.value === model.gruppo).text : ''"
              disabled
            ></b-form-input>

          </div>
          <div v-if="model.tipoDest ==='U'">
            <b-form-radio
              class="mt-2"
              v-model="model.tipoDest"
              name="some-radios"
              value="U"
              placeholder="Seleziona rapporto utenza..."
              :disabled="isReadonly ? true : model.tipoDest !=='T'"
            >Rapporto utenza specifico del Portale Patrimonio</b-form-radio>
            <b-form-input
              class="mt-1"
              type="search"
              v-model="model.utente"
              disabled
            ></b-form-input>
          </div>
        </b-form-group>

        <b-form-group
          id="input-group-1"
          label="Sezione *"
          label-for="input-1"
          label-class="font-weight-bold"
        >
          <b-form-input
            v-if="isReadonly"
            readonly
            :value="model.sezioneRiferimento"
            class="mt-1"
          />
          <b-form-select
            v-else
            class="mt-1"
            v-model="model.sezioneRiferimento"
            :options="sezioni"
          ></b-form-select>
        </b-form-group>

        <b-form-group
          id="input-group-1"
          label="Testo breve *"
          label-for="input-1"
          label-class="font-weight-bold"
        >
          <b-form-input
            id="input-1"
            v-model="model.testoBreve"
            required
            placeholder="Inserire descrizione breve..."
            :readonly="isReadonly"
          ></b-form-input>
        </b-form-group>

        <!-- numero di utenti che hanno visualizzato il messaggio rispetto al totale dei destinatari (in valore assoluto e percentuale) -->
        <div v-if="statistiche.destinatari>1">
          <pre style="font-size: 12pt">Sono stati inviati <b>{{statistiche.destinatari}}</b> messaggi.</pre>
        </div>
        <div v-else>
          <pre style="font-size: 12pt">È stato inviato <b>1</b> messaggio.</pre>
        </div>
        <b-form-group
          id="input-group-2"
          label="Utenti che hanno visualizzato il messaggio *"
          label-for="input-2"
          label-class="font-weight-bold"
        >
          <pre
            class="font-italic"
            style="font-size: 14pt"
          >Sono stati visionati {{statistiche.visionati}} messaggi ({{formatPerc((statistiche.visionati / statistiche.destinatari) ) }})</pre>
          <!-- <b-form-input
            id="input-1"
            v-model="statistiche.destinatari"
            required
            placeholder="Presa visione del messaggio"
            :readonly="isReadonly"
          ></b-form-input> -->
        </b-form-group>

        <!-- numero di utenti che hanno cliccato sul tasto "Conferma Presa Visione" del messaggio rispetto al totale dei destinatari (in valore assoluto e percentuale) -->
        <b-form-group
          id="input-group-2"
          label="Utenti che hanno letto il messaggio *"
          label-for="input-2"
          label-class="font-weight-bold"
        >
          <pre
            class="font-italic"
            style="font-size: 14pt"
          >Sono stati letti {{statistiche.letti}} messaggi ({{formatPerc((statistiche.letti / statistiche.destinatari) ) }})</pre>
          <!-- <b-form-input
            id="input-1"
            v-model="model.testoBreve"
            required
            placeholder="Inserire descrizione breve..."
            :readonly="isReadonly"
          ></b-form-input> -->
        </b-form-group>

        <!-- lista paginata degli utenti a cui è destinato il messaggio di notifica con l'informazione di "visualizzato" e "Conferma Presa Visione" -->

      </b-tab>

      <b-tab
        title="Rapporti utenza destinatari"
        v-if="tabIndex !== 1"
      >

        <b-table
          striped
          bordered
          hover
          :fields="fields"
          :items="destinatariItems"
          :responsive="true"
          :busy="false"
          :per-page="perPage"
          :currentPage="currentPage"
        >

          <!-- <template v-slot:head(icon)>
            <font-awesome-icon
              icon="search"
              size="lg"
              class="text-muted"
            />
          </template>

          <template v-slot:cell(icon)="data">
            <font-awesome-icon
              v-if="!data.item.dataPubblicazione"
              icon="pen"
              size="lg"
              class="text-primary"
            />
            <font-awesome-icon
              v-else
              icon="search"
              size="lg"
              class="text-info"
            />
          </template> -->

          <template v-slot:cell(utente)="data">
            <div class="text-nowrap">{{data.item[data.field.key]}}</div>
          </template>

          <!-- <template v-slot:cell(timeStampCreazione)="data">
            {{formatDateTime(data.item[data.field.key])}}
          </template> -->
          <template v-slot:cell(timeStampVista)="data">
            {{formatDateTime(data.item[data.field.key])}}
          </template>
          <template v-slot:cell(timeStampLettura)="data">
            {{formatDateTime(data.item[data.field.key])}}
          </template>

        </b-table>

        <div class="row justify-content-between mx-0 mt-0 mb-2 align-middle">
          <div class="text-right">
            <b-pagination
              :total-rows="totalRows"
              :per-page="perPage"
              v-model="currentPage"
              class="my-0"
            />
          </div>
          <div class="text-right">
            <b-form-group
              description="Per pagina"
              class="mb-0"
            >
              <b-form-select
                :options="pageOptions"
                v-model="perPage"
              />
            </b-form-group>
          </div>
        </div>
        <div>
          <b-button
            href="#"
            @click="downloadCSV"
          >
            Scarica dati destinatari
          </b-button>
        </div>

      </b-tab>

    </b-tabs>

  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import moment from 'moment'
import numeral from 'numeral'
import 'numeral/locales'
import LoadingSpinner from '@/components/LoadingSpinner'
import RicercaUtente from '@/components/RicercaUtente'
import { mapGetters, mapActions } from 'vuex'

const checkRangeDate = (value, vm) => {
  let retValue = !!vm.dataDa
  // console.log('retValue dataDa ? true : false', retValue)
  retValue = !!(retValue && value)
  // console.log('retValue && dataA ? true : false', retValue)
  retValue = retValue && value >= vm.dataDa
  // console.log('retValue && dataA >= dataDa', dataDa, dataA, retValue)

  return retValue
}

const checkTipoDest = (value, vm) => {
  let retValue = !!vm.tipoDest
  // console.log('retValue vm.tipoDest', vm.tipoDest, vm.gruppo, vm.utente)

  if (vm.tipoDest === 'U') {
    retValue = !!vm.utente
  } else if (vm.tipoDest === 'S') {
    retValue = !!vm.utente
  } else if (vm.tipoDest === 'G') {
    retValue = !!vm.gruppo
  } else {
    retValue = true
  }

  return retValue
}

export default {
  components: {
    LoadingSpinner,
    RicercaUtente
  },

  data () {
    return {
      fields: [
        { key: 'utente', label: 'Rapporto Utenza' },
        { key: 'nominativo', label: 'Nominativo', sortable: true },
        { key: 'codiceFiscale', label: 'Codice Fiscale', sortable: true },
        { key: 'timeStampVista', label: 'Data presa visione', sortable: true },
        { key: 'letto', label: 'Letto', sortable: true, formatter: (value) => { return value ? 'Si' : 'No' } },
        { key: 'timeStampLettura', label: 'Data Lettura', sortable: true }
      ],
      loading: true,
      id: '',
      tabIndex: 0,
      indexTab: 0,
      model: {},
      gruppi: [],
      utenti: [],
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 15, 20],
      adminUser: '',
      fileinput: '',
      fileCsv: null,
      dataPub: '',
      parametroRicerca: ''
    }
  },
  validations: {
    model: {
      sezioneRiferimento: { required },
      testoBreve: { required },
      dataDa: { required },
      dataA: { required, checkRangeDate },
      utente: { checkTipoDest },
      gruppo: { checkTipoDest },
      tipoDest: { required }
    }
  },

  async created () {
    await this.load(this.$route)
  },

  // async beforeRouteUpdate (to, from, next) {
  //   await this.load(to)
  //   next()
  // },

  computed: {
    ...mapGetters('notifiche', ['item', 'tipiRapportoUtenza', 'sezioni', 'statistiche', 'destinatariItems', 'destinatariItemsAll', 'utentiPossibili', 'destinatariRealtime']),

    isNuova () {
      return this.id === 'nuova'
    },
    isReadonly () {
      // console.log('isReadonly ()', this.item, this.item.dataPubblicazione, !!(this.item && this.item.dataPubblicazione))
      return !!(this.item && this.item.dataPubblicazione)
    },
    totalRows () {
      return this.destinatariItems.length
    },
    tuttiDestinatari () {
      return this.destinatariRealtime.tipoDest === 'T' ? this.destinatariRealtime.destinatari : 0
    },
    gruppoDestinatari () {
      return this.destinatariRealtime.tipoDest === 'G' ? this.destinatariRealtime.destinatari : 0
    },
    selezionatiDestinatari () {
      return this.destinatariRealtime.tipoDest in ['U', 'S'] ? this.destinatariRealtime.destinatari : 0
    }
  },

  methods: {
    ...mapActions('notifiche', ['loadItemById', 'loadStatisticheById', 'loadParametriNotifiche', 'addNew', 'save', 'publish', 'deleteById', 'resetItem', 'checkUtenze', 'ricercaUtenti', 'loadDestinatariRealtime']),

    back () {
      this.$router.push({ name: 'admin-notifiche' })
      // this.$router.go(-1)
    },

    reset () {
      this.back()
      this.resetItem()
    },

    async selectedDest (value) {
      // console.log('this.loadDestinatariRealtime PRIMA')
      await this.loadDestinatariRealtime({ id: this.id, userAdmin: this.adminUser, tipoDest: value, gruppo: this.model.gruppo, utente: this.model.utente })
      // console.log('this.loadDestinatariRealtime DOPO', this.statistiche, this.id)
      // console.log('B-RADIO ', value)
    },

    changeTab (tab) {
      // console.log('B-TABS ', tab, this.totalRows)
      // if (tab === 2 && !this.totalRows) {
      //   console.log('B-TABS load destinatari', tab, this.id, this.adminUser)
      //   await this.loadStatisticheById({ id: this.id, userAdmin: this.adminUser, cosa: 'dettaglio' })
      // }
    },

    // async refreshDestinatariPossibili (tipoDest) {
    //   this.loadDestinatariRealtime({ id: this.id, userAdmin: this.adminUser, cosa: 'riepilogo' })
    // },

    async load (to) {
      try {
        this.loading = true
        this.id = to.params.id
        this.tabIndex = to.params.tabIndex
        this.adminUser = to.params.userAdmin
        // console.log('id', this.id, to)
        if (this.isNuova) this.resetItem()
        else await this.loadItemById({ id: this.id, userAdmin: this.adminUser })
        // console.log('this.loadParametriNotifiche')
        this.loadParametriNotifiche()
        // console.log('Before this.model = { ...this.item }', this.item, this.adminUser)
        this.model = { ...this.item }
        this.model.fileUtenti = {}
        // console.log('After this.model = { ...this.item }', this.model)

        if (this.tabIndex !== 1) {
          // DIVERSO DA BOZZE
          // console.log('this.loadStatisticheById(this.id) PRIMA')
          await this.loadStatisticheById({ id: this.id, userAdmin: this.adminUser, cosa: 'dettaglio' })
          // console.log('this.loadStatisticheById(this.id) DOPO', this.statistiche, this.id)
        } else if (this.tabIndex === 1) {
          // await this.refreshDestinatariPossibili(model.tipoDest)
          // console.log('this.loadDestinatariRealtime PRIMA')
          await this.loadDestinatariRealtime({ id: this.id, userAdmin: this.adminUser, tipoDest: this.model.tipoDest, gruppo: this.model.gruppo, utente: this.model.utente })
          // console.log('this.loadDestinatariRealtime DOPO', this.statistiche, this.id)
        }

        // Carica statistiche messaggi
      } catch (err) {
        // console.log('Errore in load Lista notifiche')
        this.$ui.showError(err)
        // Se c'è qualsiasi tipo di problema nel caricamento della lista delle notifiche esce comunque.
        this.$router.push({ name: 'admin-notifiche' })
      }
      this.loading = false
    },

    async onSubmit () {
      // console.log('submit', this.model)

      // VERIFICA CAMPI OBBLIGATORI.
      if (!this.validate()) {
        this.$ui.notify({
          type: 'warning',
          title: 'Attenzione',
          message: 'I dati inseriti non sono corretti.'
        })
      } else {
        const formData = new FormData()

        if (this.model.file) {
          // console.log('file selezionato', this.model.file, this.model.file.name)
          formData.append('allegato', this.model.file, this.model.file.name)
          formData.append('nameFile', this.model.file.name)
          formData.append('type', this.model.file.type)
          formData.append('lenght', this.model.file.size)
        }

        this.model.gruppo = this.model.tipoDest === 'G' ? this.model.gruppo : ''
        this.model.utente = this.model.tipoDest === 'U' || this.model.tipoDest === 'S' ? this.model.utente : ''
        // this.model.utente = this.model.tipoDest === 'S' ? this.model.utente : ''
        this.model.dataDa = moment(this.model.dataDa).format('YYYY-MM-DD')
        this.model.dataA = moment(this.model.dataA).format('YYYY-MM-DD')
        // console.log('Data inizio e data fine', this.model, this.model.dataDa, this.model.dataA)

        formData.append('notifica', JSON.stringify(this.model))

        // console.log('form impostato', formData.getAll('allegato'), formData.getAll('type'), formData.getAll('lenght'))
        if (this.isNuova) await this.addNew({ id: this.model.id, formData })
        else await this.save({ id: this.model.id, userAdmin: this.adminUser, formData })
        // console.log('item', this.item)
        // this.$router.replace({ name: 'admin-notifica', params: this.item })
        this.$router.replace({ name: 'admin-notifiche' })
        // this.$router.go(-1)
      }
    },

    async onReset () {
      // console.log('reset')
      this.resetItem()
    },

    async allegaDocumento () {
      // console.log('allegaDocumento')
    },

    async pubblica () {
      // console.log('pubblica')
      await this.publish(this.model)
      this.back()
    },

    async elimina () {
      // console.log('elimina')
      await this.deleteById(this.id)
      this.back()
    },
    // onRowClicked (row) {
    //   this.$router.push({ name: 'message', params: { id: row.id } })
    // },

    calcoloDataPub (dataPubblicazione) {
      let anno = dataPubblicazione.substring(0, 4)
      let mese = dataPubblicazione.substring(5, 7)
      let giorno = dataPubblicazione.substring(8, 10)
      let dataPub = giorno.concat('/', mese, '/', anno)
      return dataPub
    },

    formatDateTime (dateStr) {
      return dateStr ? moment(dateStr).format('DD/MM/YYYY HH:mm') : ''
    },
    formatPerc (value, event) {
      numeral.locale('it')
      // console.log('value.toLocaleString()',value.toLocaleString('it-IT'), numeral(value).format())
      // return value.toLocaleString('it-IT')
      return numeral(value).format('0.000%')

      // return value
    },
    /* checkRangeDate (dataDa, dataA) {
      let retValue = !!dataDa
      // console.log('retValue dataDa ? true : false', retValue)
      retValue = !!(retValue && dataA)
      // console.log('retValue && dataA ? true : false', retValue)
      retValue = retValue && dataA >= dataDa
      // console.log('retValue && dataA >= dataDa', dataDa, dataA, retValue)

      return retValue
    }, */
    readFile: async function (fileCsvSelected) {
      if (fileCsvSelected) {
        // console.log('readFile fileCsvSelected', fileCsvSelected, fileCsvSelected.name, fileCsvSelected.type, fileCsvSelected.data)
        const scope = this
        var promiseVar = new Promise(async (resolve, reject) => {
          try {
            var reader = new FileReader()
            var file = fileCsvSelected
            reader.readAsText(file)

            reader.onload = function (e) {
              scope.fileinput = e.target.result
              resolve('complete')
            }
          } catch (error) {
            console.error(error)
            // reject('There must be an error')
          }
        })
        // let updateds = await Promise.all(promiseVar);
        promiseVar.then(data => {
          scope.afterRead(scope)
        })
      }
    },
    afterRead: async function (scope) {
      // console.log('Contenuto del file', this.fileinput)
      // write your logic for import here
      let rows = scope.fileinput.split('\n')
      let newRows = []
      rows.forEach(row => row !== '' ? newRows.push(row.trim()) : '')
      // Verifica se utenti selezionati esistono. Quelli non esistenti vengono esclusi.
      let newRowsCleaned = await scope.checkUtenze({ utenze: newRows })
      // let newRowsCleaned = scope.utenze
      // console.log('newRowsCleaned XXX', newRowsCleaned)
      let newRowsChk = []

      for (let row in newRowsCleaned) {
        // console.log('newRowsCleaned', row, newRowsCleaned[row].codiceUtente)
        newRowsChk.push(newRowsCleaned[row].codiceUtente.trim())
      }

      // console.log('Contenuto del file', rows, newRowsCleaned, newRows, newRowsChk)
      scope.model.utente = newRowsChk || newRows
    },
    validate () {
      this.$v.model.sezioneRiferimento.$touch()
      this.$v.model.testoBreve.$touch()
      this.$v.model.dataDa.$touch()
      this.$v.model.dataA.$touch()

      this.$v.model.utente.$touch()
      this.$v.model.gruppo.$touch()
      this.$v.model.tipoDest.$touch()

      let retValue = this.$v.model.tipoDest.$invalid
      // console.log('Validate tipoDest', this.$v.model.tipoDest.$invalid)

      retValue = retValue || this.$v.model.utente.$invalid
      // console.log('Validate utente', this.$v.model.utente.$invalid)
      retValue = retValue || this.$v.model.gruppo.$invalid
      // console.log('Validate gruppo', this.$v.model.gruppo.$invalid)

      retValue = retValue || this.$v.model.sezioneRiferimento.$invalid
      // console.log('Validate sezioneRiferimento', this.$v.model.sezioneRiferimento.$invalid)
      retValue = retValue || this.$v.model.testoBreve.$invalid
      // console.log('Validate testoBreve', this.$v.model.testoBreve.$invalid)
      retValue = retValue || this.$v.model.dataDa.$invalid
      // console.log('Validate dataDa', this.$v.model.dataDa.$invalid)
      retValue = retValue || this.$v.model.dataA.$invalid
      // console.log('Validate dataA', this.$v.model.dataA.$invalid)

      // console.log('Validate', retValue, !retValue)

      return !retValue
    },
    fieldState (field) {
      let v = this.$v.model[field]
      return v.$dirty && v.$error ? false : null
    },

    convertArrayOfObjectsToCSV (args) {
      let result, ctr, keys, columnDelimiter, lineDelimiter, data
      // console.log('entro dentro il converti', args)
      data = args
      if (data == null || !data.length) {
        return null
      }
      columnDelimiter = args.columnDelimiter || ';'
      lineDelimiter = args.lineDelimiter || '\n'
      keys = Object.keys(data[0])
      result = ''
      result += keys.join(columnDelimiter)
      result += lineDelimiter
      data.forEach(function (item) {
        ctr = 0
        keys.forEach(function (key) {
          if (ctr > 0) result += columnDelimiter
          result += item[key]
          ctr++
        })
        result += lineDelimiter
      })
      // console.log('result', result)
      return result
    },

    downloadCSV () {
      let data, filename, link
      let destinatari = []
      // console.log('entriamo in download', this.destinatariItemsAll.length, this.destinatariItemsAll)
      this.destinatariItemsAll.forEach(destinatariItem => {
        // console.log('dentro il ciclo', destinatariItem)
        let destinatario = {
          codiceUtente: destinatariItem.codiceUtente,
          nominativo: destinatariItem.nominativo,
          codiceFiscale: destinatariItem.codiceFiscale,
          dataPubblicazione: this.calcoloDataPub(destinatariItem.timeStampCreazione)
        }
        if (destinatariItem.timeStampVista) destinatario.dataPresaVisione = this.calcoloDataPub(destinatariItem.timeStampVista)
        else destinatario.dataPresaVisione = ''
        if (destinatariItem.letto > 0) destinatario.letto = 'SI'
        else destinatario.letto = 'NO'
        if (destinatariItem.timeStampLettura) destinatario.dataLettura = this.calcoloDataPub(destinatariItem.timeStampLettura)
        else destinatario.dataLettura = ''
        // console.log('destinatario', destinatario)
        destinatari.push(destinatario)
      })
      // console.log('destinatari', destinatari)
      let csv = {}
      csv = this.convertArrayOfObjectsToCSV(destinatari)
      if (csv == null) return
      filename = 'destinatari.csv'
      if (!csv.match(/^data:text\/csv/i)) {
        csv = 'data:text/csv;charset=utf-8,' + csv
      }
      data = encodeURI(csv)
      link = document.createElement('a')
      link.setAttribute('href', data)
      link.setAttribute('download', filename)
      link.click()
    },

    async ricercaUtente (param) {
      try {
        // console.log('parametro', param)
        await this.ricercaUtenti({ caratteri: param })
        // console.log('utentiPossibili', this.utentiPossibili)
        await this.$refs.ricerca.open()
        // Carica statistiche messaggi
      } catch (err) {
        // console.log('Errore in load Lista notifiche')
        this.$ui.showError(err)
      }
    },

    utenteScelto (utenteScelto) {
      // console.log('utente scelto', utenteScelto)
    }

  }
}
</script>

<style lang="stylus" scoped>
.in-line-element {
  display: inline;
}
</style>
